// IE polyfills
import "svgxuse";
import "core-js/stable";
import "regenerator-runtime/runtime";

import { headerSlider, moduleSliders, slidingSlider } from "./sliders";
import {
  triggerContentInView,
  triggerIntroOutOfView,
  triggerVideo,
  triggerSlidingContentSettings,
  triggerSlidingSliderControls,
  narrowSlidingSliderControls,
} from "./observers";
import addMap from "./google-map";
import activateScrollSpy from "./scrollSpy";
import openGalleriesModal from "./galleries-modal";
import initObjectsTable from "./objects-table";
import detectFiltersSticky from "./objects-sticky";
import toggleObjectsFilter from "./objects-filters";
import openModal from "./general-modal";
import addTabs from "./tabs";
import openObjectModal from "./object-modal";
import mobileObjectFunctions from "./objects-mobile";
import initForms from "./forms";
import panZoomPlan from "./objects-panzoom";
import interiorTabs from "./interior-tabs";
import { triggerParkingOverlay, initParkingTable } from "./parking-overlay";
import {
  triggerObjectLink,
  updateFloorSVG,
  triggerForm,
} from "./object-single";
import { updateFloorplansData } from "./floorplans-template";
import triggerPopUp from "./auto-popup";
import formDataLayers from "./formDataLayers";

triggerObjectLink();
updateFloorSVG();
triggerForm();
updateFloorplansData();
triggerPopUp();

const isPresent = document.getElementsByClassName("parking-overlay");
if (isPresent.length > 0) {
  triggerParkingOverlay();
  initParkingTable();
}

interiorTabs();

headerSlider();
moduleSliders();
slidingSlider();

triggerContentInView();
triggerIntroOutOfView();
triggerVideo();
triggerSlidingContentSettings();
triggerSlidingSliderControls();
narrowSlidingSliderControls();

addMap();
activateScrollSpy();
openGalleriesModal();

initObjectsTable();
detectFiltersSticky();
toggleObjectsFilter();

openModal();
openObjectModal();
addTabs();
initForms();

panZoomPlan();

mobileObjectFunctions();

function openMenu() {
  function init() {
    const hamburger = document.querySelector(".hamburger");
    const menu = document.querySelector(".mobile-menu");

    hamburger.addEventListener("click", () => {
      hamburger.classList.toggle("is-active");
      menu.classList.toggle("is-open");
      document.body.classList.toggle("mobile-menu-open");
    });
  }

  const isPresent = document.getElementsByClassName("hamburger");
  if (isPresent.length > 0) {
    init();
  }
}

openMenu();

// Turn availability filter automatically on
function triggerFilter() {
  const availFilter = document.querySelector(".availability-filter");
  availFilter.click();
}

const isPriceList = document.getElementsByClassName("availability-filter");
if (isPriceList.length > 0) {
  setTimeout(triggerFilter, 1000);
}

function showAllveelaevaInfo() {
  const isPresent = document.querySelector(".allveelaeva-content");
  if (!isPresent) {
    return;
  }

  const trigger = document.querySelectorAll(".allveelaeva-trigger");
  const content = document.querySelector(".allveelaeva-content");
  const container = document.querySelector(".buildings-select");

  trigger.forEach((el) => {
    el.addEventListener("click", () => {
      content.classList.remove("allveelaeva-content-hidden");
      container.classList.add("hidden");

      const obj = el.getAttribute("data-api-id");

      document.body.classList.add(`obj-${obj}`);
    });
  });

  // trigger.addEventListener("click", () => {
  //   content.classList.remove("allveelaeva-4-content-hidden");
  //   container.classList.add("hidden");
  //   // headerContent.classList.remove("opacity-0");
  // });

  const url = window.location.href;

  if (window.location.hash === "#allveelaeva" || url.includes("?obj=")) {
    content.classList.remove("allveelaeva-content-hidden");
    container.classList.add("hidden");
  }

  if (window.location.hash === "#allveelaeva" && !url.includes("?obj=")) {
    content.classList.remove("allveelaeva-content-hidden");
    container.classList.add("hidden");
    document.body.classList.add("obj-155");
  }

  if (url.includes("?obj=91")) {
    document.querySelector('[data-icon="91"]').classList.add("active");
    document.body.classList.add("obj-91");
    document.body.classList.remove("obj-155");
  }

  if (url.includes("?obj=155")) {
    document.querySelector('[data-icon="155"]').classList.add("active");
    document.body.classList.add("obj-155");
    document.body.classList.remove("obj-91");
  }
}

function scrollBuildingsImg() {
  const isPresent = document.querySelector(".scrollContainer");
  if (!isPresent) {
    return;
  }

  function centerScrollDiv() {
    var scrollContainer = document.querySelector(".scrollContainer");

    // Calculate the scroll position to center the content
    var scrollTo =
      (scrollContainer.scrollWidth - scrollContainer.offsetWidth + 40) / 2;

    // Set the scroll position of the container
    scrollContainer.scrollLeft = scrollTo;
  }

  // Center the div when the page has fully loaded
  window.addEventListener("load", centerScrollDiv);

  // Re-center the div whenever the window is resized
  window.addEventListener("resize", centerScrollDiv);
}

document.addEventListener("DOMContentLoaded", function () {
  scrollBuildingsImg();
  showAllveelaevaInfo();

  // Check if body has class 'home'
  if (document.body.classList.contains("home")) {
    // Function to handle scroll events
    function handleScroll() {
      if (window.scrollY > 0) {
        document.body.classList.add("scrolled");
      } else {
        document.body.classList.remove("scrolled");
      }
    }

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll);
  }

  // Check if any element with class 'modular-gradient' exists
  const elementWithGradient = document.querySelector(".modular-gradient");

  // If not, add 'extra-shadow-needed' to body
  if (
    (!elementWithGradient &&
      document.body.classList.contains(
        "page-template-template-content-page"
      )) ||
    (!elementWithGradient &&
      document.body.classList.contains(
        "page-template-template-building-info"
      )) ||
    (!elementWithGradient &&
      document.body.classList.contains("page-template-template-interior"))
  ) {
    document.body.classList.add("add-header-shadow");
  }

  const elementsWithDataUrl = document.querySelectorAll(
    ".buildings-img-overlay [data-url]"
  );

  // Add click event listener to each element
  elementsWithDataUrl.forEach((element) => {
    element.addEventListener("click", function () {
      // Retrieve the URL from the data-url attribute
      const url = this.getAttribute("data-url");

      // Navigate to the URL
      window.location.href = url;
    });
  });

  formDataLayers();
});

document.addEventListener("DOMContentLoaded", function () {
  function triggerFormInputs() {
    const isPresent = document.querySelector("#gform_fields_2");
    if (!isPresent) {
      return;
    }

    const forms = document.querySelectorAll("#gform_fields_2");

    forms.forEach(function (form) {
      const selectField = form.querySelector(".js-form-building-select select");

      const inputObjectField = form.querySelector(".js-form-object-id input");
      const inputProjectField = form.querySelector(".js-form-project-id input");

      if (selectField && inputObjectField) {
        selectField.addEventListener("change", function () {
          inputObjectField.value = selectField.value;

          if (inputObjectField.value === "155") {
            inputProjectField.value = "67";
          } else if (inputObjectField.value === "69") {
            inputProjectField.value = "40";
          } else {
            inputProjectField.value = "67";
          }
        });
      }
    });
  }

  triggerFormInputs();
});
